import { useAuth } from "../../providers/AuthProvider";
import envInfo from "../../../src/env.json";
import "./Settings.css";
import { Table } from "@mantine/core";
import { useMantineColorScheme } from "@mantine/core";


export function Settings() {

    const { toggleColorScheme } = useMantineColorScheme();

    let authContext = useAuth();

    const details:any = {
        'User name':authContext.user.name,
        'User designation':authContext.user.designation.join(','),
        'LOB': authContext.user.lob,
        'App version': envInfo.version
    }

    const configurationData = Object.keys(details).map(key => (
        <tr>
            <td className="settingsKey">{key}</td>
            <td className="settingsValue">{details[key]}</td>
        </tr>
    ));

    const toggleThemeTableRecord = (
        <tr>
            <td className="settingsKey">Theme</td>
            <td className="settingsValue">
                <button className="mode-switch active zoom" title="Switch Theme" onClick={
                    () => toggleColorScheme()
                }>
                    <svg className="moon" fill="none" stroke="currentColor" strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2" width="24" height="24" viewBox="0 0 24 24">
                        <defs />
                        <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
                    </svg>
                </button>
            </td>
        </tr>
    );

    const tableHeader = (
        <tr>
            <th className="settingsKey">Property</th>
            <th className="settingsValue">Value</th>
        </tr>
    );

    return (
        <div className="settingsPage">
            <Table striped className="settingsTable">
                {tableHeader}
                {configurationData}
                {toggleThemeTableRecord}
                
            </Table>
        </div>
    );
}
